import { FC } from "react";
import { Box, Button } from "@mui/material";
import { makeSxStyles } from "ui";
import {
  WeatherReportSeverityEnum,
  weatherReportSeverityTitleMap,
  weatherSeverityValues,
} from "service/types/enum/weather-severity-enum";

export type WeatherSeverity = `${WeatherReportSeverityEnum}`;

interface WeatherSeveritySelectorProps {
  value: WeatherSeverity;
  onChange: (severity: WeatherSeverity) => void;
}

const WeatherSeveritySelector: FC<WeatherSeveritySelectorProps> = ({
  value,
  onChange,
}) => {
  const styles = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      alignItems="center"
      gap="12px"
      sx={styles.buttons}
    >
      {weatherSeverityValues.map((severity) => (
        <Button
          key={severity}
          color="primary"
          variant={severity === value ? "contained" : "outlined"}
          onClick={() => onChange(severity)}
        >
          {weatherReportSeverityTitleMap[severity]}
        </Button>
      ))}
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  buttons: {
    "& .MuiButton-root": {
      borderRadius: "8px",
    },
    "& .MuiButton-contained:hover": {
      backgroundColor: "#005140cc",
    },
    "& .MuiButton-outlined": {
      color: "#C1C7CE",
      borderColor: "#8B9198",
    },
    "& .MuiButton-contained": {
      color: "#7EF8D4",
      backgroundColor: "#005140",
    },
  },
}));

export default WeatherSeveritySelector;
